import React, {Component} from 'react'
import PropTypes from 'prop-types'

class Status extends Component {
    _checkStatus = (bool) => {
        if (bool) {
            return <span className='Available'>Bật</span>
        }

        return <span className='Unavailable'>Tắt</span>
    }

    render() {
        const {isActive} = this.props
        const status = this._checkStatus(isActive)

        return (
            <td className="Status">
                {status}
            </td>
        )
    }
}

Status.propTypes = {
    isActive: PropTypes.bool
}

export default Status